import { defineAsyncComponent } from 'vue';
import glFeatureFlagMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import MergeReportsWidget from './merge_reports_widget.vue';
export default {
    name: 'WidgetApp',
    components: {
        MergeReportsWidget,
        MrSecurityWidget: defineAsyncComponent(()=>import('~/vue_merge_request_widget/widgets/security_reports/mr_widget_security_reports.vue')),
        MrTestReportWidget: defineAsyncComponent(()=>import('~/vue_merge_request_widget/widgets/test_report/index.vue')),
        MrTerraformWidget: defineAsyncComponent(()=>import('~/vue_merge_request_widget/widgets/terraform/index.vue')),
        MrCodeQualityWidget: defineAsyncComponent(()=>import('~/vue_merge_request_widget/widgets/code_quality/index.vue')),
        MrAccessibilityWidget: defineAsyncComponent(()=>import('~/vue_merge_request_widget/widgets/accessibility/index.vue'))
    },
    mixins: [
        glFeatureFlagMixin()
    ],
    props: {
        mr: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            emptyWidgets: {}
        };
    },
    computed: {
        testReportWidget () {
            return this.mr.testResultsPath && 'MrTestReportWidget';
        },
        terraformPlansWidget () {
            return this.mr.terraformReportsPath && 'MrTerraformWidget';
        },
        codeQualityWidget () {
            return this.mr.codequalityReportsPath ? 'MrCodeQualityWidget' : undefined;
        },
        accessibilityWidget () {
            return this.mr.accessibilityReportPath ? 'MrAccessibilityWidget' : undefined;
        },
        widgets () {
            return [
                this.codeQualityWidget,
                this.testReportWidget,
                this.terraformPlansWidget,
                'MrSecurityWidget',
                this.accessibilityWidget
            ].filter((w)=>w);
        },
        isGrouped () {
            return Boolean(this.glFeatures.mergeRequestReportsWidgetGroup && this.mr.reportsTabPath);
        },
        hasReportRows () {
            return this.widgets.some((widget)=>!this.emptyWidgets[widget]);
        }
    },
    methods: {
        onEmpty (widget, isEmpty) {
            this.emptyWidgets = {
                ...this.emptyWidgets,
                [widget]: isEmpty
            };
        }
    }
};
